import axios from "axios";
import { getMetaCsrf } from "../util/basicRenders";

export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};

export const instance = axios.create({
  baseURL: `${window.location.origin}`,
  withCredentials: true,
  // headers: {
  //           "Content-Type": "application/json"
  //         }
});

instance.interceptors.request.use(config => {
  const csrfToken = getMetaCsrf();

  // Add CSRF token to the headers
  if (config.method !== 'get' && csrfToken) {
    config.headers['x-csrf-token'] = csrfToken;
  }

  return config;
}, error => {
  // Do something with request error
  return Promise.reject(error);
});

export const instanceAuth = axios.create({
  baseURL: `${window.location.origin}`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

